import { CHAT_DB_SERVER_URL } from "../config/backend-endpoints";

// Public endpoint (no auth) — applicants are not signed-in users yet.
// Served by chat-database-server: POST /membership-applications stores a
// standalone review record (no user/subscription/payment linkage).
// Contract: notes/membership-applications.md
const APPLICATIONS_ENDPOINT = `${CHAT_DB_SERVER_URL}/membership-applications`;

export const submitMembershipApplication = async (application) => {
  const response = await fetch(APPLICATIONS_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(application),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.error || `HTTP ${response.status}: ${response.statusText}`
    );
  }

  return await response.json();
};
